import * as React from 'react';
import { components } from 'react-select';

export const StandardDropdownOption = props => {
  const { data, } = props;
  const passedProps = {...props}
  passedProps.innerProps.id = data.value

  return (
    <components.Option {...passedProps}>
      {data.label}
    </components.Option>
  );
};
